import axios from 'axios';
import qs from 'qs';
function dataURLtoFile(dataURL, filename = "archivo") {
    const [meta, base64] = dataURL.split(",");
    const mime = meta.match(/data:(.*?);base64/)?.[1] || "application/octet-stream";

    const bin = atob(base64);
    const len = bin.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);

    return new File([bytes], filename, { type: mime });
}

export const sendMail = async (mail, nombrefile, recibo) => {
    // eslint-disable-next-line no-self-compare
    const weblogin = 'https://api.muninqn.gov.ar/prod/Mail';
    const subject = `Recibo de tributo nro. ${nombrefile}`;
    const htmlBody = '<p>Municipalidad de Neuquén</p>';
    const file = dataURLtoFile(recibo, nombrefile + ".pdf");

    const fd = new FormData();
    fd.append("to", mail);
    fd.append("from", "Muni de Neuquén");
    fd.append("subject", subject);
    fd.append("body", htmlBody);
    fd.append("files", file);
    // const token = '123';
    try {
        const responseOne = await axios({
            method: 'post',
            url: weblogin,
            data: fd,
            // headers: {
            //     'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            // },
        });
        console.log(responseOne);

        return responseOne.data;
    } catch (error) {
        console.error(error);

        return null;
    }
};
export const sendMailRecibo = async (mail, recibo) => {
    // eslint-disable-next-line no-self-compare
    const weblogin = 'https://weblogin.muninqn.gov.ar/';

    const token = '123';
    const subject = `Recibo de tributo nro. ${recibo}`;
    const htmlBody = '<p>Municipalidad de Neuquén</p>';

    const url = `${weblogin}apps/Utils/public/sendMailRecibosTributarios.php`;

    try {
        const responseOne = await axios({
            method: 'post',
            url: url,
            data: qs.stringify({
                token: token,
                address: mail,
                subject: subject,
                htmlBody: htmlBody,
                reciboAdjunto: recibo,
            }),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        });

        return responseOne.data;
    } catch (error) {
        return null;
    }
};

export const sendMailSemestral = async (mail, IMPONIBLE_ID, TR1E200_ID) => {
    // eslint-disable-next-line no-self-compare
    const weblogin = 'https://weblogin.muninqn.gov.ar/';

    const token = '123';
    const subject = `Recibo Semestral `;
    const htmlBody = '<p>Municipalidad de Neuquén</p>';
    const url = `${weblogin}apps/Utils/public/sendMailSemestralTributarios.php`;
    try {
        const responseOne = await axios({
            method: 'post',
            url: url,
            data: qs.stringify({
                token: token,
                address: mail,
                subject: subject,
                htmlBody: htmlBody,
                imponibleID: IMPONIBLE_ID,
                TR1E200_ID: TR1E200_ID,
            }),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        });
        return responseOne.data;
    } catch (error) {
        return null;
    }
};
